import { Database } from "@withorbit/store-shared";
import { AttachmentStoreWeb } from "./attachmentStoreWeb.js";
import { IDBDatabaseBackend } from "./indexedDB.js";
export class OrbitStoreWeb {
    database;
    attachmentStore;
    constructor({ databaseName, indexedDB, eventReducer, }) {
        this.database = new Database(new IDBDatabaseBackend(databaseName, indexedDB), eventReducer);
        this.attachmentStore = new AttachmentStoreWeb(`${databaseName}-attachments`, indexedDB);
    }
}
//# sourceMappingURL=orbitStoreWeb.js.map